import React, { Component } from 'react';
import './style.css';

export default class Footer extends Component {
  render() {
    return (
      <footer className="footer-container w-100">
        <div className="footer-background z-2">
        </div>
        <div className="footer-social-media">
          <a className="footer-link ma0 mr3 pa0" href="https://www.instagram.com/giorgygunawan/" target="_blank" rel="noopener noreferrer">Gram</a>
          <a className="footer-link ma0 mh3 pa0" href="https://www.linkedin.com/in/giorgyg" target="_blank" rel="noopener noreferrer">Linked</a>
          <a className="footer-link ma0 mh3 pa0" href="https://dribbble.com/giorgyg" target="_blank" rel="noopener noreferrer">Dribbble</a>
        </div>
        <div className="footer-input z-2 tl dn">
          <input type="email" className="email-subscription-form w-80" name="lastname" placeholder="Enter your email here"/>
            <input type="submit" className="pointer email-subscription-form-button" value="SUBMIT"/>
        </div>
        <div className="footer-prologue z-2">
          <p>Email me at giorgygunawan@gmail.com, <br></br>or checkout my social accounts</p>
        </div>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/general/Footer/index.jsx